const OFFICIAL_GOOGLE_MAPS_BASE = 'https://maps.googleapis.com';
const DEFAULT_DEV_PROXY_BASE = 'https://maps.bikot.cn/google-maps';

function normalizeBaseUrl(base: string): string {
  return base.replace(/\/+$/, '');
}

function configuredProxyBase(): string {
  const raw = import.meta.env.VITE_GOOGLE_MAPS_API_BASE_URL;
  return typeof raw === 'string' ? raw.trim() : '';
}

/**
 * Google Maps API host.
 * - production + no VITE_GOOGLE_MAPS_API_BASE_URL → official Google
 * - production + VITE_GOOGLE_MAPS_API_BASE_URL → explicit proxy (China test hosts)
 * - development/staging → proxy (default bikot.cn, overridable)
 */
export function getGoogleMapsApiBaseUrl(): string {
  const appEnv = import.meta.env.VITE_APP_ENV || 'development';
  const proxy = configuredProxyBase();

  if (appEnv === 'production') {
    return proxy ? normalizeBaseUrl(proxy) : OFFICIAL_GOOGLE_MAPS_BASE;
  }

  return normalizeBaseUrl(proxy || DEFAULT_DEV_PROXY_BASE);
}

export function getAppEnv(): 'development' | 'staging' | 'production' {
  const raw = import.meta.env.VITE_APP_ENV || 'development';
  if (raw === 'production' || raw === 'staging') return raw;
  return 'development';
}

export function buildGoogleMapsJsUrl(apiKey: string, libraries = 'geometry,places'): string {
  // weekly channel required for PlaceAutocompleteElement (Places Autocomplete Widget).
  const params = new URLSearchParams({ key: apiKey, libraries, v: 'weekly' });
  return `${getGoogleMapsApiBaseUrl()}/maps/api/js?${params.toString()}`;
}

export function buildGoogleGeocodeUrl(
  address: string,
  apiKey: string,
  region = 'au'
): string {
  const params = new URLSearchParams({
    address,
    region,
    key: apiKey,
  });
  return `${getGoogleMapsApiBaseUrl()}/maps/api/geocode/json?${params.toString()}`;
}

export function buildGoogleReverseGeocodeUrl(
  lat: number,
  lng: number,
  apiKey: string,
  language = 'en'
): string {
  const params = new URLSearchParams({
    latlng: `${lat},${lng}`,
    language,
    key: apiKey,
  });
  return `${getGoogleMapsApiBaseUrl()}/maps/api/geocode/json?${params.toString()}`;
}
